import React from 'react';
import cn from 'classnames';
import { Grid, GridItem } from 'components/UI/Grid';
import LazyImage from 'components/UI/LazyImage';

import * as styles from './ToolIcons.module.scss';

export default function ToolIcons({ tools }) {
  return (
    <Grid md={3} lg={3} xl={3} gutterY="40px">
      {tools.map(({ title, icon, withFilter }) => (
        <GridItem key={title} Tag="div">
          <figure className={styles.tool}>
            <LazyImage
              src={icon}
              alt={title}
              className={cn(styles.icon, withFilter && styles.withFilter)}
            />
            <figcaption className={styles.iconText}>{title}</figcaption>
          </figure>
        </GridItem>
      ))}
    </Grid>
  );
}
